<template>
  <a-button
    block
    class="table-cell__actions-btn"
    type="text"
    :disabled="strategy.already_regenerated || !hasProgress"
    @click="handleShowModal"
  >
    <!-- <a-tooltip>
      <template #title>
        <template v-if="!hasProgress">
          Necesitas tener gestiones realizadas para regenerar esta tipificación
        </template>

        <template v-else> Regenerar tipificación </template>
      </template>
    </a-tooltip> -->
    <template #icon>
      <UndoOutlined
        :style="{
          fontSize: '16px',
        }"
      />
    </template>

    <a-modal
      :visible="visible"
      centered
      :width="modalWidth"
      :bodyStyle="modalBodyStyle"
      :title="modalTitle"
      :class="isPredictive ? 'modal-divider' : ''"
      cancel-text="Cancelar"
      :keyboard="false"
      :mask-closable="false"
      @cancel="handleConfirmationClose"
    >
      <p class="description">
        {{ isPredictive 
        ? 'Al regenerar la tipificación, se creará una nueva estrategia. Ingresa un nombre para poder identificarla:'
        : 'Se creará automáticamente una nueva estrategia con los resultados que elijas aquí.'
        }}
      </p>

      <a-form
        v-if="filters"
        class="form"
        layout="vertical"
        ref="formRef"
        :model="formState"
        :rules="rules"
      >
        <a-form-item :label="labelName" name="name">
          <a-input v-model:value="formState.name" placeholder="Escribir nombre aquí" />
        </a-form-item>

        <hr v-if="isPredictive"/>
        <h3 v-if="isPredictive" style="margin-bottom: 12px;">Configuración de la regeneración</h3>
        <div v-if="isPredictive">
          <a-form-item name="contact_direct">
             <span class="subtitle subtitle--switch">
              Excluir contactos con tipificación "Contacto directo"
              <a-tooltip placement="right">
                <template #title>
                  Esta opción no está disponible mientras el grupo “Contacto directo” esté seleccionado en tus filltros.
                </template>
                <a-switch 
                  style="margin-left: 6px;"
                  v-model:checked="formState.contact_direct"
                  :disabled="groupContactDirectSelected"
                  size="small"
                  @change="handleContactDirectChange"
                />
              </a-tooltip>
             </span>
             <p class="text-contact-direct">
               Al activar esta opción, se excluirán todos los teléfonos de contactos que tengan al menos una tipificación de “Contacto directo”.
             </p>
          </a-form-item>
        </div>

        <h4 v-if="isPredictive" class="subtitle">
          Filtrar teléfonos por grupo y resultado
          <a-tooltip placement="right">
            <template #title>
              <span>
                Si la opción superior está activa, solo se listarán los grupos: <strong>“Contacto indirecto”</strong> y <strong>“No contacto”</strong>.
              </span>
            </template>
            <InfoCircleOutlined style="color: #00000073; margin-left: 4px;"/>
          </a-tooltip>
        </h4>

        <div v-if="visible">
          <client-filters-input
            ref="groups"
            :item="filters.groups.available_values"
            required
            label="Grupo"
            :extra=extraGroup
            @change="handleChange('group');"
          />
          <!-- RESULTOS POR GRUPOS PARA PREDICTIVO -->
          <a-form-item ref="results" label="Resultado" required :extra="extra" v-if="isPredictive">
            <a-select
              v-model:value="filters.results.values"
              placeholder="Seleccionar"
              @change="handleChange('result');"
              mode="multiple"
              :option-label-prop="'customLabel'"
            >
              <a-select-opt-group
                v-for="g in resultsGrouped"
                :key="g.groupId"
                :label="`Grupo: ${g.groupName}`"
              >
                <a-select-option
                  v-for="item in g.items"
                  :key="item.id"
                  :customLabel="`${item.name}`"
                >
                  {{ item.name }}
                  <span v-if="g.initials" style="color: #00000073;">/ {{ g.initials }}</span>
                </a-select-option>
              </a-select-opt-group>
            </a-select>
          </a-form-item>
          <!-- RESULTOS PARA OTROS -->
          <client-filters-input
            v-else-if="resultsBySelectedGroups.length !== 0"
            ref="results"
            :item="resultsBySelectedGroups"
            label="Resultado"
            @blur="handleChange('result')"
          />
          <client-filters-input
            v-if="motivesBySelectedResults.length !== 0"
            ref="motives"
            :item="motivesBySelectedResults"
            label="Motivo"
            @blur="handleChange('motive')"
          />
          <client-filters-input
            v-if="subMotivesBySelectedMotives.length !== 0"
            ref="submotives"
            :item="subMotivesBySelectedMotives"
            label="Submotivo"
            @blur="handleChange"
          />
        </div>
      </a-form>
      <a-alert 
        v-if="isPredictive"
        :type="formState.contact_direct ? 'warning' : 'info'" 
        show-icon
      >
        <template #message>
          <template v-if="formState.contact_direct">
            <strong>Recuerda:</strong> Los contactos que tengan al menos un teléfono tipificado como <strong>“Contacto directo”</strong> no se incluirán. 
          </template>
          <template v-else>
            Por defecto, se incluirán todos los teléfonos registrados de cada contacto según los filtros seleccionados.
          </template>
        </template>
      </a-alert>

      <template #footer>
        <a-space>
          <a-button @click="handleConfirmationClose"> Cancelar </a-button>
  
          <a-tooltip :overlayInnerStyle="{ width: '152px' }">
            <template #title v-if="isRegenerateDisabled">
              Completa todos los campos requeridos.
            </template>
            <a-button
              type="primary"
              :loading="loading"
              :disabled="isRegenerateDisabled"
              @click="handleOk"
            >
              Regenerar
            </a-button>
          </a-tooltip>
        </a-space>
      </template>
    </a-modal>
    <p>Regenerar tipificación</p>
  </a-button>
</template>

<script>
import { fetchRegenerationFilters, createStrategyByRegeneration } from "@/app/strategies/services";
import { defineComponent, ref, reactive, toRaw, createVNode, computed } from "vue";
import { UndoOutlined, QuestionCircleOutlined, InfoCircleOutlined } from "@ant-design/icons-vue";
import { Modal } from "ant-design-vue";
import { StrategyType } from "@/app/shared/utils/enums";
import ClientFiltersInput from "@/app/strategies/components/drawers/ClientFiltersInput.vue";

export default defineComponent({
  components: {
    ClientFiltersInput,
    UndoOutlined,
    InfoCircleOutlined,
  },
  props: {
    strategy: {
      required: true,
      type: Object,
    },
  },
  setup(props) {
    const formRef = ref();
    const groups = ref(null);
    const motives = ref(null);
    const results = ref(null);
    const submotives = ref(null);
    const formState = reactive({
      name: "",
      contact_direct: false,
    });
    const rules = {
      name: [{ required: true, message: "Campo requerido" }],
    };

    const hasProgress = computed(() => Boolean(props.strategy?.remaining_phones));

    return {
      rules,
      formState,
      formRef,
      groups,
      motives,
      results,
      submotives,
      hasProgress,
    };
  },
  data() {
    return {
      visible: false,
      typificationsAvailable: null,
      filters: {
        groups: {
          name: "groups",
          type: "text",
          available_values: [],
        },
        results: {
          name: "results",
          type: "text",
          available_values: [],
          values: [],
        },
        motives: {
          name: "motives",
          type: "text",
          available_values: [],
        },
        submotives: {
          name: "submotives",
          type: "text",
          available_values: [],
        },
      },
      filtersSelected: null,
      loading: false,
      allowedGroupIds: [],
      groupContactDirectSelected: false,
    };
  },
  computed: {
    isRegenerateDisabled() {
      return !this.formState.name || !this.$refs?.groups?.values?.length;
    },
    isPredictive() {
      return this.strategy.type_strategy === StrategyType.predictive;
    },
    modalWidth() {
      return this.isPredictive ? "540px" : "500px";
    },
    modalBodyStyle() {
      return this.isPredictive 
        ? { padding: '16px 24px' }
        : { padding: '24px 45px' }
    },
    modalTitle() {
      const prefix = this.isPredictive
        ? "Regenerar tipificación"
        : "Regenerar con tipificación nueva";
      return `${prefix} - ${this.strategy.name}`;
    },
    labelName() {
      return this.isPredictive ? "Nombre de la nueva estrategia" : "Nombre de la regeneración";
    },
    extraGroup() {
      return this.isPredictive ? "Solo se incluirán los teléfonos de los grupos seleccionados." : "";
    },
    groupsById() {
      const groups = this.filters.groups.available_values || [];
      return groups.reduce((acc, g) => {
        acc[g.id] = g; // g: {id, name, type, ...}
        return acc;
      }, {});
    },

    groupInitialsById() {
      return Object.entries(this.groupsById).reduce((acc, [id, g]) => {
        if (g.type === 1) acc[id] = "CD";
        else acc[id] = "NC";
        return acc;
      }, {});
    },

    resultsGrouped() {
      const results = this.filters.results.available_values || [];

      const selectedGroupIds = (this.$refs?.groups?.values || [])
        .map((id) => Number(id))
        .filter((id) => !Number.isNaN(id));

      const shouldFilter = selectedGroupIds.length > 0;

      const byGroup = {};

      for (const r of results) {
        const groupId = Number(r.group);
        if (Number.isNaN(groupId)) continue;

        if (shouldFilter && !selectedGroupIds.includes(groupId)) continue;

        if (!byGroup[groupId]) byGroup[groupId] = [];
        byGroup[groupId].push(r);
      }

      const groupedArray = Object.entries(byGroup).map(([groupId, items]) => {
        const group = this.groupsById[groupId] || { id: groupId, name: `Grupo ${groupId}` };
        const initials = this.groupInitialsById[groupId] || "";
        return {
          groupId: Number(groupId),
          groupName: group.name,
          initials,
          items: items.sort((a, b) => (a.name || "").localeCompare(b.name || "")),
        };
      });

      return groupedArray.sort((a, b) => a.groupName.localeCompare(b.groupName));
    },
    resultsBySelectedGroups() {
      const selectedGroupIds = (this.$refs?.groups?.values || []).map(Number);
      
      return (this.filters.results.available_values || []).filter(r => selectedGroupIds.includes(r.group));
    },
    motivesBySelectedResults() {
      const selectedResultIds = this.$refs?.results?.values || this.filters.results.values || [];
      
      return (this.filters.motives.available_values || []).filter(m => selectedResultIds.includes(m.result));
    },
    subMotivesBySelectedMotives() {
      const selectedMotiveIds = this.$refs?.motives?.values || this.filters.motives.values || [];
      
      return (this.filters.submotives.available_values || []).filter(sm => selectedMotiveIds.includes(sm.motive));
    },
  },
  methods: {
    async fetchFilters() {
      this.typificationsAvailable = await fetchRegenerationFilters(this.strategy.id);
      if (this.formState.contact_direct) {
        this.typificationsAvailable.groups = this.typificationsAvailable.groups.filter(group => group.type !== 1);
        this.allowedGroupIds = this.typificationsAvailable.groups.map((group) => group.id);
        this.typificationsAvailable.results = this.typificationsAvailable.results.filter(result => this.allowedGroupIds.includes(result.group));
      }
      console.log("this.allowedGroupIds", this.allowedGroupIds)
      this.filters.groups.available_values = this.typificationsAvailable.groups;
      this.filters.results.available_values = this.typificationsAvailable.results;
      this.filters.motives.available_values = this.typificationsAvailable.motives;
      this.filters.submotives.available_values = this.typificationsAvailable.submotives;
      this.groupContactDirectSelected = false;
    },
    handleOk() {
      this.loading = true;

      this.formRef
        ?.validateFields()
        ?.then(async () => {
          try {
            await this.regenerateStrategy(toRaw(this.formState).name);
            await this.$store.dispatch("fetchAllStrategies");
          } catch (error) {
            console.log("error", error);
            this.$message.error("No se encontraron contactos/teléfonos con estos filtros");
          }
          this.formRef?.resetFields();
        })
        ?.catch((error) => this.$message.error(`Ha ocurrido un error - ${error}`))
        ?.finally(() => {
          this.loading = false;
          this.visible = false;
        });
    },
    async regenerateStrategy(name) {
      this.filtersSelected = [
        {
          name: "groups",
          values: this.$refs?.groups?.values || [],
        },
        {
          name: "results",
          values: this.$refs?.results?.values || this.filters.results.values || [],
        },
        {
          name: "motives",
          values: this.$refs?.motives?.values || [],
        },
        {
          name: "submotives",
          values: this.$refs?.submotives?.values || [],
        },
      ];

      await createStrategyByRegeneration(this.strategy.id, name, this.filtersSelected, this.formState.contact_direct);
    },
    handleChange(type) {
      const selectedGroupIds = (this.$refs?.groups?.values || []).map(Number);

      const contactDirectGroupId = Number(
        this.filters.groups.available_values.find(el => el.type === 1)?.id
      );

      this.groupContactDirectSelected =
        Number.isFinite(contactDirectGroupId) && selectedGroupIds.includes(contactDirectGroupId);

      if (type === 'group') {
        this.filters.results.values = [];
        this.$refs?.results?.reset();
      } else if (type === 'result') {
        this.$refs?.motives?.reset();
      } else if (type === 'motive') {
        this.$refs?.submotives?.reset();
      }
    },
    handleShowModal() {
      this.fetchFilters();
      this.visible = true;
    },
    handleConfirmationClose() {
      Modal.confirm({
        title: "¿Estás seguro de cerrar el proceso?",
        content: "Al cerrar no se guardarán los datos previamente ingresados",
        icon: createVNode(QuestionCircleOutlined),
        onOk: () => this.handleCancel(),
        centered: true,
        okText: "Cerrar",
        cancelText: "Cancelar",
      });
    },
    handleCancel() {
      this.formRef.resetFields();
      this.visible = false;
    },
    selectGroup(value) {
      const group = this.typificationsAvailable.groups.filter((item) => value.includes(item.id));
      const results = [];
      group.forEach((item) => {
        item.results.map((result) => results.push(result.id));
      });
      this.filters.results.available_values = this.typificationsAvailable.results.filter((result) =>
        results.includes(result.id)
      );
    },
    selectResult(value) {
      const result = this.typificationsAvailable.result.filter((item) => value.includes(item.id));
      const motives = [];
      result.forEach((item) => {
        item.motives.map((motive) => motives.push(motive.id));
      });
      this.filters.motives.available_values = this.typificationsAvailable.motives.filter((motive) =>
        motives.includes(motive.id)
      );
    },
    async handleContactDirectChange() {
      if (!this.visible) return;
      await this.fetchFilters();
    },
  },
});
</script>

<style lang="sass" scoped>
.description
  color: $gray-9

.ant-select-selection__rendered
  height: 60px

.form
  margin: 0 auto

.subtitle
  font-size: 14px
  font-weight: 600
  display: flex
  align-items: center
  &--switch
    margin-bottom: 4px

hr
  height: 1px
  background-color: #00000026
  border: none
  margin-top: 16px
  margin-bottom: 16px

.text-contact-direct
  font-size: 12px
  color: #000000A6
  margin-bottom: 0

strong
  font-weight: 600
</style>

